import { Box, Flex, Text, VStack, useColorModeValue } from '@chakra-ui/react';

import type { TaxFee } from 'api/quote-marketplace';
import { formatCurrency } from '../../constants';
import { calculatePremiumBreakdown } from '../../utils/premiumCalculations';

interface PremiumSummarySectionProps {
  annualPremium: string | null;
  taxes: TaxFee[] | null;
  productLabel?: string;
}

const PremiumSummarySection = ({
  annualPremium,
  taxes,
  productLabel = 'Auto',
}: PremiumSummarySectionProps) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const autoPremiumBg = useColorModeValue('blue.50', 'blue.900');
  const labelColor = useColorModeValue('gray.600', 'gray.400');

  const {
    annualPremium: annualNum,
    monthlyPremium: totalMonthly,
    taxTotal,
    taxPercentage,
    monthlyTax,
  } = calculatePremiumBreakdown(annualPremium, taxes);

  return (
    <Box>
      <VStack spacing={2} align="stretch">
        {taxTotal > 0 && (
          <Flex justify="space-between" py={1}>
            <Text fontSize="sm" color={labelColor}>
              {taxPercentage ? `${taxPercentage}% Tax Applied` : 'Tax Applied'}
            </Text>
            <Text fontSize="sm">
              {formatCurrency(String(monthlyTax.toFixed(2)))}
            </Text>
          </Flex>
        )}

        <Flex justify="space-between" py={1}>
          <Text fontSize="sm" fontWeight="600">
            Total Estimated Monthly Premium
          </Text>
          <Text fontSize="sm" fontWeight="600">
            {formatCurrency(String(totalMonthly.toFixed(2)))}
          </Text>
        </Flex>

        <Box
          bg={autoPremiumBg}
          p={4}
          borderRadius="md"
          borderWidth="1px"
          borderColor={borderColor}
          mt={2}
        >
          <Flex justify="space-between" align="center">
            <Text fontWeight="600">Total Estimated {productLabel} Premium</Text>
            <Text fontSize="xl" fontWeight="700">
              {formatCurrency(String(annualNum.toFixed(2)))}
            </Text>
          </Flex>
        </Box>
      </VStack>
    </Box>
  );
};

export default PremiumSummarySection;
